import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { authenticate, handleToken } from '../services/AuthService';
import { useAccount } from '../Context/AccountProvider';
import { getUserData } from '../services/UserService';
import { ForgotPasswordModal } from './ForgotPasswordModal';
import { FormFeedback } from './FormFeedback';

function LoginForm({ register, typeCallback }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const { updateAccountInfo } = useAccount();

  async function attemptLogin(e) {
    e.preventDefault();
    setErrorMessage('');
    setLoading(true);

    const result = await authenticate(username, password);
    if (result === undefined) {
      setLoading(false);
      setErrorMessage('Invalid credentials.');
      return;
    }

    const tokenSet = await handleToken(result);
    if (!tokenSet) {
      setLoading(false);
      setErrorMessage('Invalid login session.');
      return;
    }

    let userData = null;
    try {
      userData = await getUserData();
    } catch {
      // account exists but has no character yet
    }
    updateAccountInfo({ loggedIn: true, user: userData ?? undefined });
  }

  function handleForgotPassword() {
    if (typeCallback) {
      typeCallback('forgotPassword');
    } else {
      setShowForgotPassword(true);
    }
  }

  return (
    <>
      <Form className="lf-form" onSubmit={attemptLogin} noValidate>
        <Form.Control
          className="lf-input"
          type="text"
          placeholder="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          autoComplete="username"
          disabled={loading}
        />
        <Form.Control
          className="lf-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          autoComplete="current-password"
          disabled={loading}
        />
        <button type="button" className="lf-forgot-link" onClick={handleForgotPassword}>
          Forgot password?
        </button>
        <FormFeedback type="loading" message={loading ? 'Signing in\u2026' : null} />
        <FormFeedback type="error" message={errorMessage} />
        <Button
          className="btn-register"
          type="submit"
          disabled={loading || !username || !password}
        >
          {loading ? 'Signing in\u2026' : 'Login'}
        </Button>
        {register && (
          <div className="lf-register-row">
            <span className="lf-register-label">No account?</span>
            <LinkContainer activeClassName="" to="/register">
              <span className="lf-register-link">Register</span>
            </LinkContainer>
          </div>
        )}
      </Form>
      {!typeCallback && (
        <ForgotPasswordModal
          show={showForgotPassword}
          onHide={() => setShowForgotPassword(false)}
        />
      )}
    </>
  );
}

export { LoginForm };
